module.exports = "/_next/static/images/walletalt-b8cc2359e17bf34bc4b056591b97f7a9.svg";